import React, { useEffect, useState } from "react";
import { Person } from "@microsoft/mgt-react";
import useProfilePhoto from "../Custom/useProfilePhoto";

interface MGTProfileCardProps {
  userId: string;
  className?: string;
  style?: React.CSSProperties;
  height?: string;
}

const MGTProfileCard: React.FC<MGTProfileCardProps> = ({
  userId,
  className = "",
  style = {},
  height = "40px",
}) => {
  const { graphtoken } = useProfilePhoto();
  const [isResolvedUser, setIsResolvedUser] = useState<boolean | null>(null);

  useEffect(() => {
    let isCancelled = false;

    const validateUser = async () => {
      const trimmedUserId = (userId || "").trim();
      if (!trimmedUserId || !graphtoken) {
        setIsResolvedUser(false);
        return;
      }

      try {
        const graphEndpoint = process.env.REACT_APP_GRAPHENDPOINT;
        if (!graphEndpoint) {
          setIsResolvedUser(false);
          return;
        }

        const response = await fetch(
          `${graphEndpoint}/users/${trimmedUserId}?$select=id`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${graphtoken}`,
            },
          },
        );

        if (!isCancelled) {
          setIsResolvedUser(response.ok);
        }
      } catch {
        if (!isCancelled) {
          setIsResolvedUser(false);
        }
      }
    };

    validateUser();

    return () => {
      isCancelled = true;
    };
  }, [userId, graphtoken]);

  return (
    <div
      className={`mgt-profile-card-wrapper ${className}`}
      style={{ ...style, height, width: height, overflow: "hidden", position: "relative" }}
    >
      {isResolvedUser ? (
        <Person
          userId={userId}
          personCardInteraction="hover"
          showPresence={true}
        />
      ) : null}
    </div>
  );
};

export default MGTProfileCard;
